import { ExternalIdSource, type OrganizationProfileModel } from "api";
import { organizationRegistrationStatusesEnum } from "helpers/enums/organizationRegistrationStatuses";

/** Determine whether registration is ready for a demo based on the organization's integrations. */
export function shouldStartOrganizationDemoPeriod(
    organization: Pick<OrganizationProfileModel, "registrationStatus" | "externalIdSources">,
): boolean {
    const isAtiSuOrganization = organization.externalIdSources?.includes(ExternalIdSource.AtiSu) ?? false;

    return (
        (organization.registrationStatus === organizationRegistrationStatusesEnum.RelaySetupCompleted &&
            !isAtiSuOrganization) ||
        organization.registrationStatus === organizationRegistrationStatusesEnum.TrucksAdded
    );
}
